import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
  useTheme,
} from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import theBG from "../../../assets/images/food2.png";
import AOS from "aos";
import "aos/dist/aos.css";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import GrabButton from "../../Button/GrabButton";
const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
    backgroundColor: "transparent",
  },
}));

const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});

export default function Body() {
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Card className={classes.bg} elevation={0}>
      <CardMedia component="img" alt="bun-bo-bap" image={theBG} />
      <ThemeProvider theme={serifFont}>
        <Typography
          data-aos="zoom-in"
          data-aos-duration="1000"
          variant="h3"
          style={{
            fontWeight: "bold",
            marginTop: "1rem",
            textAlign: "center",
          }}
        >
          Bún Bò O Như
        </Typography>
      </ThemeProvider>
      <CardContent>
        <CardActions style={{ display: "flex", flexDirection: "column" }}>
          <GrabButton />
          <Typography
            variant="h6"
            style={{
              padding: theme.spacing(2),
              fontWeight: "bold",
            }}
          >
            HOẶC
          </Typography>
          <Typography variant="h5">
            <a
              href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
              target="_blank"
              rel="noreferrer"
              style={{ color: "white", textTransform: "uppercase" }}
            >
              Ăn tại quán!
            </a>
          </Typography>
        </CardActions>
      </CardContent>
    </Card>
  );
}
